import React, {useState} from "react";
import { Tabs, Card, Typography, Tooltip, Button, Drawer, Grid} from "antd";
import { ArrowLeftOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import BranchTransferPendingList from "../BranchTransferPendingList";
import BranchTransferReceiveList from "../BranchTransferReceiveList";

const { Title } = Typography;
const PurchaseReturn = () => {
  const navigate = useNavigate();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [activeTab, setActiveTab] = useState("pending_list");
  const [helpOpen, setHelpOpen] = useState(false);
  const HELP_CONTENT = {
    pending_list: {
      title: "Pending Branch Transfer Help",
      content: (
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
              marginLeft:"12px"
            }}
          >
            Pending Transfer List
          </h2>

          <p style={{ color: "#555", marginBottom: "16px", marginLeft:20}}>
            The Pending Transfer List is used to monitor branch transfer
            transactions that are awaiting confirmation or receiving.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Available Actions</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>View pending branch transactions</li>
              <li>Verify transfer amounts and details</li>
              <li>Track pending inward branch entries</li>
              <li>Monitor transaction statuses</li>
              <li>Review branch account information</li>
            </ol>
          </div>
        </div>
      ),
    },

    recived_list: {
      title: "Received Branch Transfer Help",
      content: (
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
              marginLeft: "12px"
            }}
          >
            Received Transfer List
          </h2>

          <p style={{ color: "#555", marginBottom: "16px", marginLeft:20 }}>
            The Received Transfer List is used to monitor completed inward
            branch transaction receipts within the ERP system.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Available Actions</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>View received branch transfers</li>
              <li>Verify inward transaction details</li>
              <li>Monitor completed transfer entries</li>
              <li>Track received transaction amounts</li>
              <li>Review finalized inward transactions</li>
            </ol>
          </div>
        </div>
      ),
    },
  };
  return (
    <div className="p-4">
      <Card
        className="shadow-md rounded-xl mb-4"
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Button
              type="text"
              icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
              onClick={() => navigate(-1)}
              data-testid="branch-transaction-inward-back-button"
            />
            <Title
              level={4}
              style={{ margin: 0 }}
              className="reportBigTitle"
            >
              Branch Transaction Inward
            </Title>

            <div style={{ marginLeft: "auto" }}>
              <Tooltip title="Help">
                <Button
                  type="text"
                  icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
                  onClick={() => setHelpOpen(true)}
                />
              </Tooltip>
            </div>
          </div>
        }
        styles={{
          header: { borderBottom: "none", padding: "12px 16px" },
          body: { padding: 0 },
        }}
      />{" "}
      
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        type="card"
        size="medium"
        style={{ marginBottom: 32 }}
        items={[
          {
            label: "Pending List",
            key: "pending_list",
            children: <BranchTransferPendingList />
          },
          {
            label: "Recived List",
            key: "recived_list",
            children: <BranchTransferReceiveList />
          },
        ]}
      />
      <Drawer
        title={HELP_CONTENT[activeTab]?.title}
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={420}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
        destroyOnClose
      >
        {HELP_CONTENT[activeTab]?.content}
      </Drawer>
    </div>
  );
};

export default PurchaseReturn;
